import { Box } from "@mui/material";
import { KeyDriveBodyMin } from "../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { Check } from "@mui/icons-material";

export interface IRegisterIndicator {
    numberIndicate: number;
    isActualStep: boolean;
    isStepConclued: boolean;
}

interface IRegisterIndicatorWrapper {
    isActualStep: boolean;
    children: React.ReactNode;
}

function RegisterIndicatorWrapper({
    children,
    isActualStep
}: IRegisterIndicatorWrapper) {
    return (
        <Box
            width="24px"
            height="24px"
            bgcolor="transparent"
            border={`${isActualStep ? "1px solid #22638D" : "1px solid #7AA1BB" }`}
            borderRadius="4px"
            marginRight="10px"
            display="flex"
            justifyContent="center"
            alignItems="center"
            marginBottom="16px"
        >
            { children }
        </Box>
    )
}

export default function RegisterIndicator({
    isActualStep,
    numberIndicate,
    isStepConclued
}: IRegisterIndicator) {

    if (isStepConclued) {
        return (
            <RegisterIndicatorWrapper
                isActualStep={isActualStep}
            >
                <Check 
                    sx={{
                        color: "#22638D"
                    }}
                />
            </RegisterIndicatorWrapper>
        )
    }

    if (isActualStep) {
        return (
            <RegisterIndicatorWrapper
                isActualStep={isActualStep}
            >
                <Box 
                    width="6px"
                    height="6px"
                    sx={{
                        backgroundColor: `${isActualStep ? "#22638D" : "#7AA1BB" }`
                    }}
                />
            </RegisterIndicatorWrapper>
        )
    }

    return (
        <RegisterIndicatorWrapper
            isActualStep={isActualStep} 
        >
            <KeyDriveBodyMin
                color={`${isActualStep ? "#22638D" : "#7AA1BB" }`}
                needBold={false}
                needEllipses={false}
                text={numberIndicate.toString()}
            />
        </RegisterIndicatorWrapper>
    )
}